<template>
    <span :style="{ cursor: isClickable ? 'pointer' : 'default' }">
        <b-badge pill v-if="badgeVariant" :variant="badgeVariant" :style="{ fontSize: `${badgeSize}rem` }">
            {{ value }}
        </b-badge>
        <span v-else :class="{ 'text-primary': isClickable, 'interactive-bg': isClickable }">
            {{ value }}
        </span>
    </span>
</template>
<script>
    export default {
        computed: {
            badgeVariant() {
                return this.params.badgeVariant(this.params);
            },
            isClickable() {
                return this.params.isClickable === true;
            },
        },
        data() {
            return {
                value: null,
            };
        },
        created() {
            this.value = this.params.value;
            this.badgeSize = this.params.badgeSize ? this.params.badgeSize : 0.9;
        },
    };
</script>
<style lang="scss" scoped>
    .interactive-bg {
        background-color: rgba(0, 123, 255, 0.05);
        padding: 2px 5px;
        border-radius: 3px;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: rgba(0, 123, 255, 0.1);
        }
    }
</style>
